import { html, TemplateResult, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import globalStyles from './styles/outline-admin-menu.global.pcss?inline';
import encapsulatedStyles from './styles/outline-admin-menu.encapsulated.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
/**
 * The element name, reused throughout the codebase
 * @type {string}
 */
const componentName = 'outline-admin-menu';

/**
 * The Outline Core AdminMenu component
 *
 * A reusable LitElement component for displaying admin-menus.
 *
 * @element outline-admin-menu
 * @extends LitElement
 */
@customElement(componentName)
export class OutlineAdminMenu extends LitElement {
  /**
   * Adopted stylesheets for the component
   *
   * @type {AdoptedStyleSheets}
   */
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: encapsulatedStyles,
  });

  connectedCallback() {
    super.connectedCallback();
    }


  render(): TemplateResult {
    return html` <div class="links"><slot></slot></div> `;
  }
}

/**
 * Declare the component in the global HTMLElementTagNameMap
 */
declare global {
  interface HTMLElementTagNameMap {
    [componentName]: OutlineAdminMenu;
  }
}
